import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=4f049246&scoped=true&lang=pug&"
import script from "./step_4.vue?vue&type=script&lang=js&"
export * from "./step_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f049246",
  null
  
)

export default component.exports